import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Import',
  baseUrl: '/admin/seller/import',
  routes: [
    {
      path: '/',
      page: 'InquiryPage',
      title: 'Inquiry Page',
      exact: true
    },
    {
      path: '/:productId',
      page: 'InquiryDetailPage',
      title: 'Inquiry Detail Page',
      exact: true
    },
    {
      path: '/stock',
      page: 'ImportStock',
      title: 'Import Stock Page',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
